import React from 'react';

// Catches render/lifecycle exceptions in its subtree and shows a fallback
// instead of unmounting the whole React root to a blank white screen — the
// worst failure mode for a monitoring dashboard. Used both at the app root and
// around each tab's content so one bad tab can't take down the shell.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Log for diagnostics; keep the shell alive.
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const label = this.props.label ? ` (${this.props.label})` : '';
    return (
      <div style={{
        margin: 24, padding: 24, borderRadius: 16,
        backgroundColor: '#0f172a', border: '1px solid #7f1d1d',
        color: '#e2e8f0', fontFamily: 'inherit',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
          <span style={{ fontSize: 20 }}>⚠️</span>
          <h2 style={{ color: '#fca5a5', fontSize: 16, fontWeight: 700, margin: 0 }}>
            Something went wrong{label}
          </h2>
        </div>
        <p style={{ color: '#94a3b8', fontSize: 13, margin: '0 0 14px' }}>
          This view hit an error and was isolated so the rest of the dashboard keeps running.
        </p>
        <pre style={{
          color: '#f87171', fontSize: 12, whiteSpace: 'pre-wrap', wordBreak: 'break-word',
          background: '#1e293b', padding: 12, borderRadius: 8, maxHeight: 160, overflow: 'auto', margin: '0 0 14px',
        }}>{String(error?.message || error)}</pre>
        <div style={{ display: 'flex', gap: 10 }}>
          <button onClick={this.reset} style={{
            padding: '8px 16px', borderRadius: 8, border: 'none',
            backgroundColor: '#22c55e', color: '#052e16', fontSize: 13, fontWeight: 700, cursor: 'pointer',
          }}>Try again</button>
          <button onClick={() => window.location.reload()} style={{
            padding: '8px 16px', borderRadius: 8, border: '1px solid #334155',
            backgroundColor: 'transparent', color: '#cbd5e1', fontSize: 13, cursor: 'pointer',
          }}>Reload dashboard</button>
        </div>
      </div>
    );
  }
}
